<template>
  <div>
    <router-view
      class="shows-route-episodes-route-container"
      keep-alive
      transition="app"
      transition-mode="out-in">
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'EpisodesRoute',

  components: {
  },

  data () {
    return {
    };
  },

  computed: {
  },

  methods: {
  },

  watch: {
  }
};
</script>
